import {
  EMAIL_TEMPLATE_FILL_FIELD_ATTRIBUTE,
  EMAIL_TEMPLATE_PLACEHOLDER_ATTRIBUTE,
  type EmailTemplatePlaceholder,
} from '@immo/api-contract';
import { sanitiseEmailTemplateHtml } from '@/lib/email/sanitise-email-template-html';
import { createOpenFieldChip } from './open-field-interaction';
import { createPersonalLinkChip } from './personal-link';

export type RenderForComposerOptions = {
  // The context Interessent has a personal page: `{Link zur persönlichen Seite}` becomes the unmarked chip the
  // backend turns into the link at sending (IMM-1177.7). Otherwise it stays marked and blocks sending.
  readonly personalLink?: boolean;
};

/** Stored markup → composer nodes: valued placeholders as text, the rest as marked chips. */
export function renderTemplateForComposer(
  markup: string,
  values: Partial<Record<EmailTemplatePlaceholder, string>>,
  labels: (key: string) => string,
  options: RenderForComposerOptions = {},
): DocumentFragment {
  const template = document.createElement('template');

  template.innerHTML = sanitiseEmailTemplateHtml(markup);

  for (const span of Array.from(
    template.content.querySelectorAll(
      `[${EMAIL_TEMPLATE_PLACEHOLDER_ATTRIBUTE}], [${EMAIL_TEMPLATE_FILL_FIELD_ATTRIBUTE}]`,
    ),
  )) {
    const key = span.getAttribute(EMAIL_TEMPLATE_PLACEHOLDER_ATTRIBUTE);

    if (key === null) {
      span.replaceWith(createOpenFieldChip(`[${span.getAttribute(EMAIL_TEMPLATE_FILL_FIELD_ATTRIBUTE) ?? ''}]`));

      continue;
    }

    if (key === 'PROSPECT_PERSONAL_LINK' && options.personalLink === true) {
      span.replaceWith(createPersonalLinkChip(labels(key)));

      continue;
    }

    const value = (values as Record<string, string | undefined>)[key];

    span.replaceWith(value === undefined ? createOpenFieldChip(`{${labels(key)}}`) : document.createTextNode(value));
  }

  return template.content;
}
